export default "__VITE_ASSET__BJXKDqwf__"